import { render, staticRenderFns } from "./baike.vue?vue&type=template&id=7ad690be&scoped=true"
import script from "./baike.vue?vue&type=script&lang=js"
export * from "./baike.vue?vue&type=script&lang=js"
import style0 from "./baike.vue?vue&type=style&index=0&id=7ad690be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad690be",
  null
  
)

export default component.exports